import type {ReactElement} from 'react';
import type {AiChatLogoProps} from './ai-chat-logo.types';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {AiChatLogoButton} from './components/ai-chat-logo-button/ai-chat-logo-button';
import {useAiChat} from '@/ai-chat/providers/ai-chat.context';
import {onLogoClick} from '@Libraries/ai-chat.library';

export function AiChatLogo({...props}: AiChatLogoProps): ReactElement {
  const {state, actions} = useAiChat();
  const onHamburgerMenuClick = (): void => {
    actions.setIsSidebarExpanded(!state.isSidebarExpanded);
  };

  return (
    <div className="flex-row-align-center">
      {props.showHamburgerMenu ? (
        <Icon
          onClick={onHamburgerMenuClick}
          icon="icon-bars"
          className="radius-8 spacing-m-r-1"
          size={IconSize.SIZE_ICON_16}
          shape={IconShape.SQUARE}
          type={IconType.GHOST}
          isUsedAsButton
        />
      ) : null}
      <AiChatLogoButton onClick={onLogoClick} />
    </div>
  );
}
